import React from "react";
import { Theme } from "../../theme";

export const CircleCheckIcon = ({ fill, ...props }) => {
    return (
        <svg
            id="Icon-Check-Circle"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            {...props}
        >
            <path
                id="Icon-Check"
                d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0m0,21a9,9,0,1,1,9-9h0a9,9,0,0,1-9,9M16.73,7.306,18.5,8.929l-6.637,7.236.035.035-.808.809-.815.888-.038-.035L10.2,17.9l-.815-.815-.88-.807.035-.038L4.9,12.6l1.7-1.7,3.563,3.563Z"
                transform="translate(0 0)"
                fill={fill ? fill : Theme.colors.blue}
            />
        </svg>
    );
};
